import React, {Component, PropTypes} from 'react';
import ReactDOM from 'react-dom';

import fitting from './fitting.js';
import config from '../../config';

import StoreConnect from '../../flux/StoreConnect';
import tooltipStore from '../../stores/tooltip';

class Tooltip extends Component {
  constructor() {
    super();
    this.state = {
      boxPosition: false
    };
    this.getPosition = this.getPosition.bind(this);
  }

  componentWillReceiveProps() {
    setTimeout(this.getPosition, 0);
  }

  // Use the fitting module to find the best location for the tooltip
  getBestPosition(anchorPoint, containerDimensions, labelDimensions) {
    var boxDimensions = ReactDOM.findDOMNode(this).getBoundingClientRect();

    var bestLocation = fitting.best(anchorPoint, boxDimensions, containerDimensions, labelDimensions);

    if (bestLocation) {
      return {
        direction: bestLocation.direction,
        style:     {
          left: bestLocation.x,
          top:  bestLocation.y
        }
      };
    }

    return false;
  }

  isChanging() {
    const {tooltip} = this.props;
    return tooltip.isHovering || tooltip.isPanning || tooltip.isZooming;
  }

  getPosition() {

    var anchorElement = this.props.tooltip.el;
    var containerEl = document.getElementById('map-container');

    if (!anchorElement || !containerEl || this.isChanging()) {
      return false;
    }

    var labelDimensions = ReactDOM.findDOMNode(anchorElement).getBoundingClientRect();
    var containerDimensions = containerEl.getBoundingClientRect();

    var anchorPoint = {
      x: labelDimensions.left - containerDimensions.left + (labelDimensions.width / 2),
      y: labelDimensions.top - containerDimensions.top + (labelDimensions.height / 2)
    };

    var boxPosition = this.getBestPosition(anchorPoint, containerDimensions, labelDimensions);

    this.setState({
      boxPosition: boxPosition
    });
  }

  render() {
    // TODO, add validation
    const { props, el } = this.props.tooltip;

    if (!props || !props.type) {
      return false;
    }

    const TooltipViews = config.tooltip.views;
    const TooltipView = TooltipViews ? TooltipViews[props.type] : false;

    if (!TooltipView) {
      return false;
    }

    var boxPosition = this.state.boxPosition;

    var className = 'map-tooltip';
    className += el && boxPosition ? ' is-active' : '';
    className += this.isChanging() ? ' is-changing' : '';
    className += boxPosition ? ' ' + boxPosition.direction : '';
    className += props.variation ? ' ' + props.variation : '';

    var boxStyle = boxPosition ? boxPosition.style : {};

    return (
      <div data-component="tooltip" style={boxStyle} className={className}>
        <div className="map-tooltip__content">
          <TooltipView {...props}/>
        </div>
      </div>
    );
  }
}

Tooltip.propTypes = {
  tooltip: PropTypes.object.isRequired
};

export default StoreConnect(Tooltip, {tooltip: tooltipStore});



// WEBPACK FOOTER //
// ./frontend/react/sim/core/components/tooltip/index.jsx